"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("../utils/redux");
var constants_1 = require("../constants");
var get_1 = __importDefault(require("lodash/get"));
exports.initialState = {
    isConnected: false,
    name: null,
    shareUrl: null,
    pinCode: null,
    airPlayEnabled: false,
    isPresentationActive: false
};
/**
 * Stores 'hdmiPresentation' related data.
 * @example
 * store
 *   +-- nucleus
 *     +-- sharePresentation
 *       +-- isConnected: bool
 *       +-- name: string
 *       +-- shareUrl: string
 *       +-- pinCode: string
 *       +-- airPlayEnabled: bool
 *       +-- isPresentationActive: bool
 */
exports.default = redux_1.createReducer(exports.initialState, (_a = {},
    _a[constants_1.app.actions.setSharePresentationInfo] = function (state, action) { return (__assign(__assign({}, state), { isConnected: get_1.default(action, 'payload.isConnected'), shareUrl: get_1.default(action, 'payload.shareUrl'), airPlayEnabled: get_1.default(action, 'payload.airPlayEnabled'), pinCode: get_1.default(action, 'payload.pinCode'), name: get_1.default(action, 'payload.name') })); },
    _a[constants_1.app.actions.setSharePinCode] = function (state, action) { return (__assign(__assign({}, state), { pinCode: get_1.default(action, 'payload') })); },
    _a[constants_1.app.actions.setSharePresentationActive] = function (state, action) { return (__assign(__assign({}, state), { isPresentationActive: get_1.default(action, 'payload') })); },
    _a));
